import React from 'react'
import { LGYAddress } from 'app/components/util/lgy-field/LgyField'

const DisplayHomeBuilders = ({ totalListLength, pageResults, handleNewSearch }) =>
  <div className='builder-results usa-grid'>
    <h1>Builder Report Results</h1>
    <span className='records-found'>
      <h4>Records found: {totalListLength}</h4>
      <button onClick={handleNewSearch}>New Search</button>
    </span>
    <table className='builder-display-table'>
      <thead>
        <tr>
          <th scope='col' className='name'>Company Name (ID)</th>
          <th scope='col' className='status'>Status</th>
          <th scope='col' className='address'>Address</th>
        </tr>
      </thead>
      <tbody>
        {pageResults.map(builder =>
          <tr className='builder-display-row' key={builder.id}>
            <td>
              {builder.builderFirmName} ({builder.builderBuisnessId})
              {builder.principalNames && <span>Principal(s): {builder.principalNames.map((name, index) =>
                index !== builder.principalNames.length - 1 ? `${name.replace(',', '')}, ` : `${name.replace(',', '')}`)}</span>}
            </td>
            {builder.statusCode === '0' ? <td>Active</td> : <td>Inactive</td>}
            <td><LGYAddress
              streetAddress1={builder.addressOne}
              streetAddress2={builder.addressTwo}
              city={builder.city}
              state={builder.state}
              zip={builder.zipCode}
              zipSuffix={builder.zipPlusFour} />
            </td>
          </tr>)}
      </tbody>
    </table>
  </div>

export default DisplayHomeBuilders
